import { BaseFormViewModel} from "../../../../../shared/ui-ndms/view-models/base-form.view-model";
import {FormGroup, Validators, FormArray, FormControl, ValidatorFn, ValidationErrors} from "@angular/forms";
import {LookupViewModel} from "../../../../../shared/ui-ndms/view-models/lookup.view-model";
import {PersonNameViewModel} from "../../../../../shared/ui-ndms/view-models/person-name.view-model";
import {FormObjects} from "../../../../../shared/core/utilities/formObjects";
import {LookupModel} from "../../../api/models/lookup-model";
import {PatientIdentifierViewModel} from "./patient-identifier.view-model";
import * as moment from "moment";
import {NdmsUtils} from "../../../../../shared/core/utilities/ndmsUtils";
import { JpatsFormObjects } from "../../core-jpats/utilities/jpatsFormObjects";
import { NdmsValidators } from "../../../../../shared/ui-ndms/forms/ndmsValidators.validators";

export class PatientViewModel extends BaseFormViewModel{
    name?: PersonNameViewModel = new PersonNameViewModel();
    firstName?: string = undefined;
    lastName?: string = undefined;
    isUnaccompaniedMinor?: boolean = false;
    age?: number;
    ageQualifier?: string = "Years";
    notes?:string;
    driversLicenseNumber?: string = undefined;
    gender?: LookupModel = undefined;
    patientHealthStatus?: LookupModel = undefined;
    injuryNatureDescription?: string= undefined;
    birthDate?: string= undefined;
    nationality?: LookupModel = undefined;
    patientBedType?: LookupModel = undefined;
    patientType?: LookupModel = undefined;
    socialSecurityNumber?: string = undefined;
    patientKey?: string = undefined;
    key?: string = undefined;
    metadataKey?: string = undefined;
    identifierNumber?:string= undefined;
    identifierType?: LookupModel = undefined;
    identifiers?:  PatientIdentifierViewModel[] = new Array<PatientIdentifierViewModel>();
    encodedImage?: string = undefined;

  constructor(initializer?: any) {
    super();
    NdmsUtils.initObj(this, initializer);
  }
  identityRevealedValidator: ValidatorFn = (control: FormGroup): ValidationErrors => {
    let age = control.get('age');
    let birthDate = control.get('birthDate');
    if((!age || !birthDate) || ((!age.value)&& !birthDate.value)){
      return {'ageOrDobRequired':true};
    }
    if (age.value && age.value < 0)
      return {'ageInvalid': 'age cannot be negative'};
    if (birthDate.value) {
      let dateOfBirthMoment: moment.Moment = moment(birthDate.value);
      let dayDiff: number = moment().diff(dateOfBirthMoment, 'days');
      if (dayDiff < 0 )
        return {'dboInvalid': 'Date of Birth cannot be a future date'};

      let age: number = moment().diff(dateOfBirthMoment, 'years');
      if (age > 144)
        return {'dboInvalid': 'age should be less than 144'};
    }
    return [];
  };


    toFormGroup(existingFormGroup?: FormGroup): FormGroup {
        let formGroupData = {
            firstName: FormObjects.String(this.name!.firstName  || this.firstName, [Validators.required]),
            lastName: FormObjects.String(this.name!.lastName || this.lastName, [Validators.required]),
            isUnaccompaniedMinor:  FormObjects.Boolean(this.isUnaccompaniedMinor),
            age: FormObjects.Number(this.age),
            driversLicenseNumber: FormObjects.String(this.driversLicenseNumber, [NdmsValidators.noSpace]),
            gender: FormObjects.Lookup(this.gender,[Validators.required]),
            ageQualifier: FormObjects.String(this.ageQualifier,[Validators.required]),
            notes: FormObjects.String(this.notes),
            socialSecurityNumber: FormObjects.SocialSecurityNumber(this.socialSecurityNumber),
            birthDate: FormObjects.DefaultDate(this.birthDate),
            nationality: FormObjects.Lookup(this.nationality),
            patientHealthStatus: FormObjects.Lookup(this.patientHealthStatus),
            injuryNatureDescription: FormObjects.String(this.injuryNatureDescription),
            patientBedType: FormObjects.Lookup(this.patientBedType),
            patientType: FormObjects.Lookup(this.patientType),
            identifierNumber: FormObjects.String(this.identifierNumber, [NdmsValidators.noSpace]),
            identifierType:FormObjects.Lookup(this.identifierType),
            patientKey: FormObjects.String(this.key),
            key: FormObjects.String(this.key),
            encodedImage: FormObjects.String(this.encodedImage),
            metadataKey:FormObjects.String(this.metadataKey)
        };

        let newFormGroup = new FormGroup(formGroupData, this.identityRevealedValidator );
        let formGroup = existingFormGroup || newFormGroup;
        if (this.birthDate && this.birthDate !== '') {
            let ageFormControl = (<FormControl>formGroup.get('age'));
            ageFormControl.setValue(this.getAge());
        }
        if (existingFormGroup) {
            formGroup.patchValue(newFormGroup.value);
        }
        else {
            formGroup.addControl('identifiers', new FormArray([]));
        }
        if(this.identifiers){
            BaseFormViewModel.clearFormArray((<FormArray>formGroup.get('identifiers')));

            this.identifiers.forEach((value: any) => {
                if (value != undefined) {
                    let identifierViewModel = new PatientIdentifierViewModel();
                    identifierViewModel.identifierNumber = value.identifierNumber;
                    identifierViewModel.patientKey = this.key;
                    identifierViewModel.identifierType = value.identifierType; 
                    identifierViewModel.metadataKey = value.metadataKey;
                    identifierViewModel.hashCode = value.hashCode;
                    (<FormArray>formGroup.get('identifiers')).push(JpatsFormObjects.Wristband(identifierViewModel))
                }
            })
        }
        return formGroup;
    }



    populateAge(){
      this.age = this.getAge();
    }
    getAge(){
      if(this.birthDate && this.birthDate !== ''){
        let dateOfBirthMoment: moment.Moment = moment(this.birthDate);
        return moment().diff(dateOfBirthMoment, 'years');
      }
      else
          return this.age;
    }
    static fromFormModel(formModel: any): PatientViewModel {
        let patientViewModel: PatientViewModel = new PatientViewModel({
            identifierNumber: formModel.identifierNumber,
            identifierType: formModel.identifierType,
            birthDate: formModel.birthDate,
            firstName: formModel.firstName,
            lastName: formModel.lastName,
            gender: formModel.gender,
            isUnaccompaniedMinor: formModel.isUnaccompaniedMinor,
            age: formModel.age,
            ageQualifier: formModel.ageQualifier,
            notes: formModel.notes,
            driversLicenseNumber: formModel.driversLicenseNumber,
            patientHealthStatus: formModel.patientHealthStatus,
            patientType: formModel.patientType,
            patientBedType: formModel.patientBedType,
            injuryNatureDescription: formModel.injuryNatureDescription,
            nationality: formModel.nationality,
            key: formModel.key,
            name: {
                firstName: formModel.firstName,
                lastName: formModel.lastName
            },
            socialSecurityNumber: formModel.socialSecurityNumber,
            metadataKey: formModel.metadataKey
        });

        return patientViewModel;
    }
}
